<main>
  <section class="about-section">
    <div class="content-wrapper">
      <div class="columns is-vcentered">
        <div class="column is-half">
          <h1 class="title is-2">
            Digital Marketing & Web Development
            <span class="highlight">Agency in Goa</span> — Serving Clients
            Globally
          </h1>
          <p class="subtitle">
            At Geekeno, we deliver tailored digital experiences that help
            businesses grow online. Based in Goa, India, our team of
            strategists, designers, and developers blends creativity with
            technology to build scalable solutions in digital marketing, custom
            website development, SEO, and branding. Whether you're a local
            startup or an international brand, we craft data-driven strategies
            that drive visibility, engagement, and measurable results.
          </p>
        </div>
        <div class="column is-half has-text-right-tablet">
          <img
            src="/assets/about/about-hero.webp"
            alt="Digital Business"
            loading="eager"
            fetchpriority="high"
            width="790"
            height="569"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="about-geekeno-section">
    <div class="content-wrapper">
      <div class="columns is-vcentered">
        <div class="column is-full-touch">
          <img
            src="assets/about/about-geekeno2.webp"
            alt="Geekeno team in Goa office"
            class="about-geekeno-image"
            loading="eager"
            width="431"
            height="300"
          />
        </div>
        <div class="column is-full-touch">
          <p class="about-geekeno-subtitle">ABOUT GEEKENO</p>
          <h2 class="about-geekeno-title">
            Getting to know Geekeno <br />
            and our passion
          </h2>
          <p class="about-geekeno-text">
            We're not just another digital agency. Geekeno is a
            multidisciplinary team of strategists, designers, and developers
            dedicated to helping businesses grow online. Whether you're
            launching a new brand or scaling your digital presence, we deliver
            tailored solutions that drive results.
          </p>
          <br />
          <p class="about-geekeno-text">
            We collaborate with clients across India and internationally,
            offering:
          </p>
          <ul class="about-geekeno-text">
            <li>‧ Custom website development</li>
            <li>‧ SEO and digital marketing</li>
            <li>‧ Graphic design and branding</li>
            <li>‧ Scalable software and app solutions</li>
          </ul>
          <br />
          <p class="about-geekeno-text">
            Let's turn your ideas into impactful digital experiences.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="services-section">
    <div class="content-wrapper">
      <div class="has-text-centered">
        <h2
          class="has-text-primary is-uppercase is-size-3 has-text-weight-semibold"
        >
          Our Services
        </h2>
        <p class="title is-4 pb-5 is-size-3">
          Digital Solutions That Drive <br />
          Growth in Goa & Beyond
        </p>
      </div>

      <div class="columns is-multiline">
        @for (service of services; track service.title) {
          <div class="column is-full is-half-tablet is-one-third-desktop">
            <div class="card is-flex is-flex-direction-column is-fullheight">
              <div class="card-content has-text-centered">
                <div class="icon has-text-primary is-size-3 mb-2">
                  <fa-icon [icon]="service.iconClass" />
                </div>
                <h3 class="title is-5 mt-3 has-text-weight-bold">
                  {{ service.title }}
                </h3>
                <p>{{ service.description }}</p>
              </div>
              <div class="card-footer">
                <a
                  [href]="service.url"
                  class="card-footer-item has-text-primary"
                  >Read More →</a
                >
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <section class="section-brand-kit">
    <div class="content-wrapper">
      <div class="columns is-vcentered is-variable is-8">
        <div class="column is-half has-text-centered">
          <figure class="image is-inline-block">
            <img
              src="/assets/products/brand-kit/standout-personal-brand.svg"
              alt="Personal Brand Kit"
              loading="lazy"
            />
          </figure>
        </div>

        <div class="column is-half">
          <h2 class="title is-3 mb-3">
            Build your <span class="has-text-primary">Personal Brand Kit</span>
          </h2>
          <p class="subtitle is-6 mb-4">
            Whether you're a coach, creator, or small business owner — your
            online presence deserves clarity and consistency. With Geekeno's
            <strong>Personal Brand Kit</strong>, you'll get everything you need
            to stand out: your logo, color palette, bio set, Canva templates,
            and 15-day content plan.
          </p>

          <div class="columns is-mobile is-multiline mt-0 mb-4">
            <div class="column is-half">
              <p>
                <fa-icon
                  [icon]="icons.palette"
                  class="has-text-primary"
                />&nbsp; Brand Colors
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon [icon]="icons.idCard" class="has-text-primary" />&nbsp;
                Bios & Voice Guide
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon [icon]="icons.images" class="has-text-primary" />&nbsp;
                Canva Templates
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon
                  [icon]="icons.calendar"
                  class="has-text-primary"
                />&nbsp; 15-Day Content Plan
              </p>
            </div>
          </div>

          <div class="buttons is-centered">
            <a href="/products/brand-kit" class="button is-primary is-medium">
              <span class="icon"><fa-icon [icon]="icons.rocket" /></span>
              <span>Explore the Brand Kit</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-rekavoze has-background-light">
    <div class="content-wrapper">
      <div class="columns is-vcentered is-variable is-8 is-reversed-mobile">
        <div class="column is-half">
          <h2 class="title is-3 mb-3">
            Simplify Your Business with
            <span class="has-text-primary">Rekavoze</span>
          </h2>
          <p class="subtitle is-6 mb-4">
            Stop juggling spreadsheets. <strong>Rekavoze</strong> is our
            intuitive inventory and expense management tool built specifically
            for SMBs. Track real-time stock, Categorize expenses, and gain
            actionable profit insights — all in one dashboard.
          </p>

          <div class="columns is-mobile is-multiline mt-0 mb-4">
            <div class="column is-half">
              <p>
                <fa-icon
                  [icon]="icons.inventory"
                  class="has-text-primary"
                />&nbsp; Inventory Mastery
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon
                  [icon]="icons.expense"
                  class="has-text-primary"
                />&nbsp; Expense Tracking
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon
                  [icon]="icons.analytics"
                  class="has-text-primary"
                />&nbsp; Profit Analytics
              </p>
            </div>
            <div class="column is-half">
              <p>
                <fa-icon [icon]="icons.budget" class="has-text-primary" />&nbsp;
                Budget Control
              </p>
            </div>
          </div>

          <div class="buttons is-centered">
            <a href="/products/rekavoze" class="button is-primary is-medium">
              <span class="icon"><fa-icon [icon]="icons.rocket" /></span>
              <span>Discover Rekavoze</span>
            </a>
          </div>
        </div>
        <div class="column is-half has-text-centered">
          <picture>
            <source
              srcset="/assets/products/rekavoze/dashboard-dark.avif"
              media="(prefers-color-scheme: dark)"
            />
            <img
              src="/assets/products/rekavoze/dashboard.avif"
              alt="Rekavoze Dashboard Preview"
              width="1920"
              height="1080"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </div>
  </section>

  <section class="project-section">
    <div class="content-wrapper">
      <h2 class="title is-3 has-text-primary is-uppercase">
        Featured Projects
      </h2>
      <p class="subtitle is-5">
        A select few of our finest projects for clients across India.
      </p>

      <website-grid
        [items]="projects"
        [enableFilter]="true"
        fieldToFilterBy="category"
        gridClasses="fixed-grid has-1-cols has-2-cols-tablet has-3-cols-desktop has-4-cols-widescreen"
      >
        <ng-template let-project="item">
          <div class="card">
            <div class="card-image">
              <div class="image is-3by2">
                @if (project.videoUrl) {
                  <app-lazy-video
                    [src]="project.videoUrl"
                    [poster]="project.imageUrl"
                    [autoplay]="true"
                    [loop]="true"
                    [muted]="true"
                    [playsinline]="true"
                    class="media-content"
                    [height]="475"
                    [width]="712"
                  />
                }
                @if (!project.videoUrl) {
                  <img
                    [src]="project.imageUrl"
                    [alt]="project.alt"
                    loading="lazy"
                    height="475"
                    width="712"
                  />
                }
              </div>
            </div>
            <div class="card-content has-text-centered">
              <p class="title is-6">{{ project.title }}</p>
              <p class="subtitle is-7">{{ project.category }}</p>
            </div>
          </div>
        </ng-template>
      </website-grid>
    </div>
  </section>

  <section class="trusted-by">
    <div class="content-wrapper">
      <h2 class="has-text-centered has-text-weight-bold">
        We Are Glad To Be Trusted By!
      </h2>
      <website-carousel
        mainContentClass="about-us-carousel"
        [items]="clients"
        [showThumbnails]="false"
        [numberOfRows]="numberOfClientRows"
        [numberOfItemsToShowTogetherPerRow]="numberOfClientsPerRow"
        gapBetweenColumns="2rem"
        gapBetweenRows="2rem"
        mainContentAspectRatio="initial"
        [autoScrollSpeed]="autoScrollClients ? 1000 : 0"
      />
    </div>
  </section>
</main>
